import { Badge, BlockStack, InlineStack, Text } from '@shopify/polaris'
import { getStatusConfig } from '../lib/status'
import { currencySymbol } from '../lib/currency'

type Props = {
    status: string | null
    amount: string | null
    currency: string | null
    paymentId: string | null
    // True while an authorization call is in flight (manual click or the
    // automatic server-side request). Shows a spinner + "Requesting Guarantee"
    // so the merchant sees it's working and doesn't re-request (double guarantee).
    requesting?: boolean
}

export function PaymentStatus({ status, amount, currency, paymentId, requesting }: Props) {
    // While requesting, show the spinner + a transient "Requesting Guarantee"
    // badge. Once a status lands (e.g. processing -> "Authorizing"), show that as
    // a plain badge with NO spinner — the provider decision can take a while and
    // resolves asynchronously via the BNPLX callback.
    const config = requesting
        ? { tone: 'info' as const, label: 'Requesting Guarantee' }
        : getStatusConfig(status)
    const symbol = currencySymbol(currency || 'EUR')

    return (
        <BlockStack gap="300">
            <Text as="h2" variant="headingMd">Payment</Text>
            <InlineStack gap="300" blockAlign="center">
                <Badge tone={config.tone as any}>{config.label}</Badge>
                {amount && (
                    <Text as="span" variant="headingLg" fontWeight="bold">
                        {symbol}{parseFloat(amount).toFixed(2)}
                    </Text>
                )}
            </InlineStack>
            {paymentId && (
                <Text as="p" tone="subdued" variant="bodySm">
                    {paymentId}
                </Text>
            )}
        </BlockStack>
    )
}
